import React from 'react';
import { Mail, Phone, MapPin, Linkedin, Twitter, Facebook, Instagram, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { companyInfo, navigationLinks } from '../data/mock';
import { engineeringImages } from '../data/images';

const Footer = () => {
  return (
    <footer className="footer-industrial">
      {/* Footer Top with Image */}
      <div className="footer-image-section">
        <img src={engineeringImages.cadDesign} alt="Engineering Excellence" />
        <div className="footer-image-overlay"></div>
        <div className="container-main footer-cta-content">
          <h2 className="footer-cta-title">Ready to Start Your Next Project?</h2>
          <p className="footer-cta-subtitle">
            Let's discuss how we can help bring your mechanical design vision to life
          </p>
          <Link to="/contact" className="btn-industrial-primary">
            Get Started <ArrowRight size={20} />
          </Link>
        </div>
      </div>

      {/* Main Footer Content */}
      <div className="footer-main-content">
        <div className="container-main">
          <div className="footer-grid-industrial">
            {/* Company Info */}
            <div className="footer-column">
              <div className="footer-logo">
                <div className="footer-logo-icon">C</div>
                <div>
                  <h3 className="footer-logo-name">{companyInfo.name}</h3>
                  <p className="footer-logo-tagline">Engineering Excellence</p>
                </div>
              </div>
              <p className="footer-description">
                {companyInfo.description}
              </p>
              <div className="footer-social">
                <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="footer-social-icon" aria-label="LinkedIn">
                  <Linkedin size={18} />
                </a>
                <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="footer-social-icon" aria-label="Twitter">
                  <Twitter size={18} />
                </a>
                <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="footer-social-icon" aria-label="Facebook">
                  <Facebook size={18} />
                </a>
                <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="footer-social-icon" aria-label="Instagram">
                  <Instagram size={18} />
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div className="footer-column">
              <h4 className="footer-column-title">Quick Links</h4>
              <ul className="footer-links">
                {navigationLinks.map((link) => (
                  <li key={link.name}>
                    <Link to={link.path} className="footer-link-item">
                      <ArrowRight size={14} />
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Services */}
            <div className="footer-column">
              <h4 className="footer-column-title">Our Services</h4>
              <ul className="footer-links">
                <li><span className="footer-link-item"><ArrowRight size={14} />Concept Design</span></li>
                <li><span className="footer-link-item"><ArrowRight size={14} />3D Modeling & Drafting</span></li>
                <li><span className="footer-link-item"><ArrowRight size={14} />Design for Manufacture</span></li>
                <li><span className="footer-link-item"><ArrowRight size={14} />Reverse Engineering</span></li>
                <li><span className="footer-link-item"><ArrowRight size={14} />Quality Control</span></li>
              </ul>
            </div>

            {/* Contact Info */}
            <div className="footer-column">
              <h4 className="footer-column-title">Get In Touch</h4>
              <ul className="footer-contact-list">
                <li className="footer-contact-item">
                  <div className="footer-contact-icon">
                    <Mail size={18} />
                  </div>
                  <div>
                    <span className="footer-contact-label">Email Us</span>
                    <a href={`mailto:${companyInfo.email}`} className="footer-contact-value">
                      {companyInfo.email}
                    </a>
                  </div>
                </li>
                <li className="footer-contact-item">
                  <div className="footer-contact-icon">
                    <Phone size={18} />
                  </div>
                  <div>
                    <span className="footer-contact-label">Call Us</span>
                    <a href={`tel:${companyInfo.phone}`} className="footer-contact-value">
                      {companyInfo.phone}
                    </a>
                  </div>
                </li>
                <li className="footer-contact-item">
                  <div className="footer-contact-icon">
                    <MapPin size={18} />
                  </div>
                  <div>
                    <span className="footer-contact-label">Visit Us</span>
                    <span className="footer-contact-value">{companyInfo.address}</span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom-industrial">
        <div className="container-main">
          <div className="footer-bottom-content">
            <p className="footer-copyright-text">
              © {new Date().getFullYear()} {companyInfo.name}. All rights reserved.
            </p>
            <div className="footer-bottom-links">
              <Link to="/privacy" className="footer-bottom-link">Privacy Policy</Link>
              <span className="footer-divider">|</span>
              <Link to="/terms" className="footer-bottom-link">Terms of Service</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
